export const MTLS_CHECK_NAMES = {
  REACHABLE: 'reachable',
  SERVER_CERT_VALID: 'server_cert_valid',
  MTLS_ENFORCED: 'mtls_enforced',
  CLIENT_CERT_VALID: 'client_cert_valid',
  IP_WHITELISTING: 'ip_whitelisting',
} as const;

export type MtlsCheckName =
  (typeof MTLS_CHECK_NAMES)[keyof typeof MTLS_CHECK_NAMES];

export const MTLS_CHECK_STATUSES = {
  PASS: 'PASS',
  WARN: 'WARN',
  FAIL: 'FAIL',
} as const;

export type MtlsCheckStatus =
  (typeof MTLS_CHECK_STATUSES)[keyof typeof MTLS_CHECK_STATUSES];

export interface MtlsProbeResult {
  name: string;
  status: MtlsCheckStatus;
  detail: string;
  enforcement?: string;
}

export interface MtlsCheckResult {
  // `name` stays a plain string so new checks added by the agent still render.
  name: string;
  status: MtlsCheckStatus;
  detail: string;
  expiry?: string;
  days_until_expiry?: number;
  probes?: MtlsProbeResult[];
  ip_whitelisting_scenario?: string;
}

export interface MtlsVerification {
  id: string;
  environment_id: string;
  base_url?: string;
  status: string;
  overall_verdict?: string;
  checks?: MtlsCheckResult[];
  server_cert_expiry?: string;
  public_key_hash?: string;
  raw_openssl_output?: string;
  error?: string;
  created_at: string;
  completed_at?: string;
}

export interface MtlsVerificationCreated {
  id: string;
  status: string;
}

/**
 * A verification is settled once the agent stamps a completion time or a
 * top-level error. The `status` string is not an enum in the API contract,
 * so termination is derived from these fields instead.
 */
export const isMtlsVerificationSettled = (
  verification?: MtlsVerification | null,
) => {
  return Boolean(verification?.completed_at || verification?.error);
};
